<div class="container-fluid px-5 py-3">
    <div class="d-flex pb-2">
        <span class="text-blue font-weight-bold">
            <h3 translate>fiscalReceipts.report</h3>
        </span>
    </div>
    <div class="my-2 py-2">
        <!-- ******************************************************
        ************** Search Card Form *************
        ****************************************************** -->
        <form [formGroup]="searchForm">
            <div class="input-group mb-2">
                <!-- store -->
                <div>
                    <span class="input-group-text" translate>fiscalReceipts.store</span>
                </div>
                <select class="custom-select" aria-describedby="storeId" formControlName="storeId" style="max-width: 220pt;" (change)="onStoreChange()">
                    <!-- A КТП employee is pinned to their own store, so the empty option is
                         dropped - leaving it would let them clear the filter and see every one. -->
                    <option *ngIf="!hasTechnicalPoint" value="" translate>placeholder.select</option>
                    <option *ngFor="let s of stores" [value]=s.storeId>
                        {{s.name}}
                    </option>
                </select>

                <!-- date from -->
                <div class="ml-2">
                    <span class="input-group-text" id="dateFrom" translate>technicalInspection.startDate</span>
                </div>
                <input class="form-control d-inline" aria-describedby="dateFrom" style="max-width: 130pt;"
                       formControlName="dateFrom" ngbDatepicker #d1="ngbDatepicker" readonly>
                <button class="btn btn-outline-secondary fa fa-calendar" (click)="d1.toggle()" type="button" style="height: 38px; border-radius: 0;"></button>

                <!-- date to -->
                <div class="ml-2">
                    <span class="input-group-text" id="dateTo" translate>technicalInspection.endDate</span>
                </div>
                <input class="form-control d-inline" aria-describedby="dateTo" style="max-width: 130pt;"
                       formControlName="dateTo" ngbDatepicker #d2="ngbDatepicker" readonly>
                <button class="btn btn-outline-secondary fa fa-calendar" (click)="d2.toggle()" type="button" style="height: 38px; border-radius: 0;"></button>

                <!-- cash register -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>fiscalReceipts.cashRegister</span>
                </div>
                <select class="custom-select" aria-describedby="cashRegisterId" formControlName="cashRegisterId" style="max-width: 250pt;">
                    <option value="" translate>placeholder.select</option>
                    <option *ngFor="let c of filteredCashRegisters" [value]=c.cashRegisterId>
                        {{c.name}}
                    </option>
                </select>

                <!-- actions -->
                <div class="input-group-append ml-2 action-buttons">
                    <button class="btn btn-outline-success" type="button" (click)="search()" translate>button.search</button>
                    <button class="btn btn-outline-danger ml-2" type="button" (click)="clearSearch()" translate>button.clear</button>
                </div>
            </div>
        </form>
        <br>
        <!-- ******************************************************
        ************** Table Data *************
        ****************************************************** -->
        <!-- table-responsive belongs on the wrapper, not the table: Bootstrap gives it
             display:block, which makes a table shrink to its content and ignore w-100. -->
        <div class="table-responsive">
            <table class="table table-bordered table-striped w-100" [hidden]="!dataLoaded">
                <thead>
                    <tr>
                        <th style="width: 20%;" scope="col" translate>fiscalReceipts.store</th>
                        <th style="width: 12%;" scope="col" translate>references.date</th>
                        <th style="width: 14%;" scope="col" translate>fiscalReceipts.documentNumber</th>
                        <th style="width: 12%;" scope="col" translate>fiscalReceipts.price</th>
                        <th style="width: 16%;" scope="col" translate>references.createdDate</th>
                        <th style="width: 18%;" scope="col" translate>fiscalReceipts.completedBy</th>
                        <th style="width: 8%;" scope="col" translate>col.actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of content">
                        <td>{{item.storeName}}</td>
                        <td>{{item.date}}</td>
                        <td>{{item.documentNumber}}</td>
                        <td>{{item.total | number:'1.2-2'}}</td>
                        <td>{{item.createDate}}</td>
                        <td>{{item.completeUserName}}</td>
                        <td class="text-center py-2">
                            <button class="btn btn-sm btn-primary" type="button" (click)="viewReceipt(item)"
                                data-toggle="tooltip" data-placement="bottom" title="{{'button.view' | translate}}">
                                <i class="fa fa-eye fa-lg"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>
        <!-- ******************************************************
        ************** Pagination *************
        ****************************************************** -->
        <div class="paging-wrapper d-flex justify-content-between action-pagination">
            <select class="pagination-size custom-select" [(ngModel)]="sortingPaging.pageSize" [ngModelOptions]="{standalone: true}" (change)="onPageSizeChange($event)">
                <option *ngFor="let item of pageSizeOptions; let i = index" [value]="pageSizeOptions[i]">
                    {{pageSizeOptions[i]}} {{'paging.itemsPerPage' | translate}}
                </option>
            </select>
            <ngb-pagination class="pagination-control" [(page)]="sortingPaging.pageNumber"
                [pageSize]="sortingPaging.pageSize" [collectionSize]="sortingPaging.totalElements"
                [boundaryLinks]="true" [maxSize]="maxSize" (pageChange)="pageChanged($event)">
            </ngb-pagination>
            <span class="pagination-index border center">
                {{sortingPaging.fromRow}} - {{sortingPaging.toRow}} / {{sortingPaging.totalElements}}
            </span>
        </div>
    </div>
</div>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <em class="fa fa-refresh" (click)="reload()"></em>
        </div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>
